import React from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import SkeletProfile from 'Skelet/src/components/Profile.js';
import WorkExperience from './WorkExperience.js';
import WorkHighlight from './WorkHighlight.js';

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'


// bij multi/metadata nog maxlength handling

class Profile extends React.Component {

  componentWillMount() {
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "profile", "GET", config.api_url+"/profile?t="+this.props.session_token);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "profile", "GET", config.api_url+"/profile?t="+nextProps.session_token);
    }
    let profile = this.props.apiData["profile"];
    let next_profile = nextProps.apiData["profile"];
    let profile_defined = profile !== undefined && !profile.isFetching && profile.data[0] !== undefined;
    let next_profile_defined = next_profile !== undefined && !next_profile.isFetching && next_profile.data[0] !== undefined;
    if(profile_defined && next_profile_defined && profile.data[0] !== next_profile.data[0]) this.props.clearStateBlock("cv_"+profile.data[0].username);
  }

  render() {
    document.title = "Curvit CV Maker";
    let profile = this.props.apiData["profile"];
    let profile_defined = profile !== undefined && !profile.isFetching && profile.data[0] !== undefined;
    return <div className="container thin-container" style={{marginTop:"2em"}}>
      {!profile_defined && <p>Claim a username to start adding your Work Experience as well.</p>}
      {profile_defined && <a href={"/@"+profile.data[0].username} target="_blank">View CV</a>}
      <SkeletProfile
        lang = {this.props.app_language}
        config = {config}
        fields = {[{type:"text", dbcol:"username", placeholder:"Username *", maxLength:"64"},
        {type:"textarea", dbcol:"biography", placeholder:"Biography", maxLength:"5000", rows:3},
        {type:"color", dbcol:"accent_background", placeholder:"Accent Background", maxLength:"6"},
        {type:"color", dbcol:"accent_color", placeholder:"Accent Color", maxLength:"6"},
        {type:"contacts", dbcol:"contact_json", placeholder:"Contact information", maxLength:"1000"},
        {type:"multi", dbcol:"links_json", placeholder:"Links", maxLength:"1000"}]}
        required_fields = {[{dbcol:"username", name:"Username"}]}
        validate_fields = {[{dbcol:"username", name:"Username"}]}
        api_method = "PATCH"
        api_endpoint = "/profile-update"
        api_block = "update_profile"
        api_block_clear = "profile"
      />
      {!profile_defined && <p>Claim a username to start adding your Work Experience as well.</p>}
      {profile_defined && <a href={"/@"+profile.data[0].username} target="_blank">View CV</a>}
      {profile_defined && <WorkExperience />}
      {profile_defined && <br/>}
      {profile_defined && <a href={"/@"+profile.data[0].username} target="_blank">View CV</a>}
      {profile_defined && <WorkHighlight />}
      {profile_defined && <br/>}
      {profile_defined && <a href={"/@"+profile.data[0].username} target="_blank">View CV</a>}
    </div>;
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile)



// WEBPACK FOOTER //
// ./src/containers/Profile.js